import styled from 'styled-components'
//import { device } from '../../theme'

export const Content = styled.div`
    ul {
        list-style: outside;
        margin: 0 0 1.45rem 1.45rem;
    }
`
